import { UserRoleEnum } from "@nlc/shared-types";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

import { FeaturePageLayout } from "@/features/shared";

import CreateAdmin from "./components/CreateAdmin";
import CreateCollaborator from "./components/CreateCollaborator";
import CreateOwner from "./components/CreateOwner";
import CreateTeamMember from "./components/CreateTeamMember";
import { SelectRole } from "./components/SelectRole";

const TEAM_MEMBER_ROLES = new Set([
  UserRoleEnum.SuperAdmin,
  UserRoleEnum.TeamLeader,
  UserRoleEnum.Designer,
  UserRoleEnum.CustomerSuccess,
]);

function resolveForm(roleId: number) {
  if (roleId === UserRoleEnum.Owner) return <CreateOwner />;
  if (roleId === UserRoleEnum.Administrator) return <CreateAdmin />;
  if (roleId === UserRoleEnum.Collaborator) return <CreateCollaborator />;
  if (TEAM_MEMBER_ROLES.has(roleId))
    return <CreateTeamMember roleId={roleId} />;

  return null;
}

export default function CreateUser() {
  const [role, setRole] = useState("0");
  const roleId = Number(role);
  const form = resolveForm(roleId);

  return (
    <div className="p-xl">
      <FeaturePageLayout title="New user">
        <div className="bg-bg-primary p-xl">
          <SelectRole role={role} setRole={setRole} />
          <AnimatePresence mode="wait">
            {form && (
              <motion.div
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                initial={{ height: 0, opacity: 0 }}
                key={roleId}
                style={{ overflow: "hidden" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              >
                {form}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </FeaturePageLayout>
    </div>
  );
}
